import { useFavorites } from '@tunasong/ui-lib'
import { Header } from '../header.js'
import { Breadcrumbs, IconButton, Link, type AppBarProps } from '@mui/material'
import { Link as RouterLink } from 'react-router'
import { Favorite, FavoriteBorder, Home, type IconName } from '@tunasong/icons'

export interface PageHeaderProps extends AppBarProps {
  name?: string
  pageIconName?: IconName
  ref?: React.Ref<HTMLDivElement>
  showBackButton?: boolean
}

export const PageHeader = (props: PageHeaderProps) => {
  const { name, ref, showBackButton = true, pageIconName, ...appBarProps } = props
  const { currentFavorite, addFavorite, removeFavorite } = useFavorites()

  // @todo copy-and-pasted from entity-header.tsx
  const linkProps = {
    color: 'inherit',
    sx: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 1,
      fontWeight: 300,
      textDecoration: 'none',
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
      },
    },
  }

  return (
    <Header
      ref={ref}
      position="absolute"
      elevation={0}
      controls={[
        name ? (
          <IconButton
            key={0}
            color={currentFavorite ? 'error' : 'inherit'}
            onClick={ev => {
              ev.preventDefault()
              ev.stopPropagation()
              if (currentFavorite) {
                removeFavorite(currentFavorite)
              } else {
                addFavorite({ name, iconName: pageIconName })
              }
            }}
            aria-label={currentFavorite ? 'Remove from favorites' : 'Add to favorites'}
          >
            {currentFavorite ? <Favorite /> : <FavoriteBorder />}
          </IconButton>
        ) : null,
      ].filter(Boolean)}
      showBackButton={showBackButton}
      breadcrumbs={
        <Breadcrumbs aria-label="breadcrumb" sx={{ margin: 0, ...props.sx }}>
          <Link
            sx={{
              ...linkProps.sx,
              marginRight: '0px !important',
              color: theme => theme.vars.palette.action.disabled,
            }}
            component={RouterLink}
            color="inherit"
            to="/app"
            title="Home link"
            aria-label="Home link"
          >
            <Home sx={{ marginRight: '0px !important', width: 24, height: 24 }} color="inherit" />
          </Link>
          {name ? (
            <Link component={RouterLink} {...linkProps} sx={{ ...linkProps.sx, fontSize: 14 }} to={`.`} title={name}>
              {name}
            </Link>
          ) : null}
        </Breadcrumbs>
      }
      {...appBarProps}
    />
  )
}
